import {http} from "./http";

export function updateMembership(membershipId, membership) {
    return  http.put(`v1/memberships/${membershipId}`, {...membership});
}

export function sendConfirmationEmail(membershipId) {
    return http.post(`v1/memberships/confirm-mail/${membershipId}`);
}

export function deleteMembershipById(membershipId) {
    return http.delete(`v1/memberships/${membershipId}`);
}
